module.exports = require('./lib/_stream_writable.js');



// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/writable-browser.js